import React from "react";
import CheckoutDeepLink from "~/components/checkoutDeepLink";

const CheckoutDeepLinkPage = () => {
	return <CheckoutDeepLink />;
};

export default CheckoutDeepLinkPage;
